import { Dependence, DependenceWhat, DependenceWhatMap } from '../index';

function treeshakeImport(
  importFieldMap: Map<string, boolean>,
  dependencies: Array<Dependence>
): { deps: Array<Dependence>; depMap: Map<string, number> } {
  const deps: Array<Dependence> = [];
  const depMap: Map<string, number> = new Map();
  if (!dependencies.length) return { deps, depMap };

  for (let len = dependencies.length - 1; len >= 0; len--) {
    const dep = dependencies[len];
    const what = dep.what;
    const whatMap = dep.whatMap;
    if (!what || !what.length) {
      removeImport(len);
      continue;
    }
    traverseWhat(what, whatMap);
    if (!what || !what.length) {
      removeImport(len);
      continue;
    }
    depMap.set(dep.moduleAbsolutePath, deps.length);
    deps.push(dep);
  }

  function removeImport(index: number) {
    dependencies.splice(index, 1);
  }
  function traverseWhat(
    whats: Array<DependenceWhat>,
    whatMap: DependenceWhatMap
  ) {
    for (let len = whats.length - 1; len >= 0; len--) {
      const what = whats[len];
      const whatName = what.binding;
      if (!importFieldMap.has(whatName) || !importFieldMap.get(whatName)) {
        whats.splice(len, 1);
        whatMap.delete(whatName);
      }
    }
    return whats;
  }
  return { deps, depMap };
}
export { treeshakeImport };
